"use strict";

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.search");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlStringBuilder = void 0;

var _queryString = require("query-string");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var urlStringBuilder = function urlStringBuilder(search) {
  var getQueryParams = function getQueryParams(url) {
    if (typeof window === 'undefined') {
      return {
        toObject: function toObject() {},
        toString: function toString() {
          return '';
        }
      };
    }

    var locationSearchSource = search || window.location.search;
    var urlSource = url;

    var query = _objectSpread({}, (0, _queryString.parse)(locationSearchSource), {}, (0, _queryString.parse)((0, _queryString.extract)(urlSource)));

    return {
      toObject: function toObject() {
        return query;
      },
      toString: function toString() {
        return (0, _queryString.stringify)(query);
      }
    };
  };

  var createQueryString = function createQueryString(url) {
    var searchParams = [];

    var mergeWithQueryParams = function mergeWithQueryParams() {
      var paramsArg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var queryParamsObject = getQueryParams(url).toObject();

      var merged = _objectSpread({}, queryParamsObject, {}, paramsArg);

      return merged;
    };

    var arrayToObject = function arrayToObject() {
      var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return array.reduce(function (accumulator, _ref) {
        var key = _ref.key,
            value = _ref.value;
        accumulator[key] = value;
        return accumulator;
      }, {});
    };

    var cleanURL = function cleanURL(dirtyURL) {
      return dirtyURL.split('?')[0];
    };

    var queryBuilder = {
      addParams: function addParams() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.entries(params).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
              key = _ref3[0],
              value = _ref3[1];

          return queryBuilder.addParam(key, value);
        });
        return queryBuilder;
      },
      addParam: function addParam(key, value) {
        searchParams.push({
          key: key,
          value: value
        });
        return queryBuilder;
      },
      build: function build() {
        var queryParamsObject = mergeWithQueryParams(arrayToObject(searchParams));
        var queryParamsString = (0, _queryString.stringify)(queryParamsObject);
        var cleanedURL = cleanURL(url);
        var builtURL = queryParamsString ? [cleanedURL, queryParamsString].join('?') : url;
        return {
          url: builtURL,
          getQueryParamsInObject: function getQueryParamsInObject() {
            return queryParamsObject;
          },
          getQueryParamsInString: function getQueryParamsInString() {
            return queryParamsString;
          }
        };
      }
    };
    return queryBuilder;
  };

  return {
    createQueryString: createQueryString
  };
};

exports.urlStringBuilder = urlStringBuilder;